import InArticleAdsenseComponent from './InArticleAdsenseComponent.vue'

const InArticleAdsense = {
  install: Vue => {
    Vue.component('InArticleAdsense', InArticleAdsenseComponent)
  }
}

export default InArticleAdsense
